import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';
import SpinnerWithMessage from './SpinnerWithMessage';

class SurveyPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
    this.onLoadComplete = this.onLoadComplete.bind(this);
    this.close = this.close.bind(this);
  }

  onLoadComplete() {
    this.setState({ isLoading: false });
  }

  close() {
    this.props.onClose();
  }

  render() {
    return (
      <div data-testId="SurveyPopup" className={Classes.surveyPopup.surveyFeedbackContainer}>
        <div className={Classes.surveyPopup.surveyFeedbackContent}>
          {
            this.state.isLoading
            && (
            <div className={Classes.surveyPopup.surveyLoadingCircle}>
              <SpinnerWithMessage message={this.props.spinnerMessage} isBig className={Classes.surveyPopup.surveySpinnerContainer} />
            </div>
            )
          }

          <div
            className={Classes.surveyPopup.surveyFeedbackclose}
            onClick={this.close}
            role="button"
            tabIndex={0}
          >
            <i className={Classes.surveyPopup.surveyFeedbackcloseIcon} />
          </div>
          <iframe
            style={{ borderRadius: '6px' }}
            onLoad={this.onLoadComplete}
            src={this.props.uri}
            height="90%"
            width="100%"
            scrolling="yes"
            sandbox="allow-forms allow-scripts"
            title="VerintPopup"
            frameBorder="0"
          />
        </div>
      </div>
    );
  }
}

SurveyPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  uri: PropTypes.string.isRequired,
  spinnerMessage: PropTypes.string.isRequired
};

export default SurveyPopup;
